import { baseApi } from '../../app/api/baseApi'
const fileNameFrom = (disposition) => {
    const match = /filename\*?=(?:UTF-8'')?"?([^";]+)"?/i.exec(disposition || '')
    return match ? decodeURIComponent(match[1].trim()) : 'installer.zip'
}
const saveFile = (blob, fileName) => {
    const url = window.URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', fileName)
    document.body.appendChild(link)
    link.click()
    link.remove()
    window.URL.revokeObjectURL(url)
}
export const installersApi = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        downloadInstaller: builder.mutation({
            async queryFn(body, api, extraOptions, baseQuery) {
                const result = await baseQuery({
                    url: '/Client/connections/download',
                    method: 'POST',
                    body,
                    responseHandler: (response) => response.blob()
                })
                if (result.error) {
                    return { error: result.error }
                }
                const fileName = fileNameFrom(result.meta.response.headers.get('content-disposition'))
                saveFile(new Blob([result.data], { type: 'application/zip' }), fileName)
                return { data: { fileName } }
            }
        }),
        setupInstaller: builder.mutation({
            query: (body) => ({ url: '/Client/connections/setup', method: 'POST', body })
        })
    })
})

export const { useDownloadInstallerMutation, useSetupInstallerMutation } = installersApi
